export const NO_TRANSCRIPTION_MESSAGE = 'No transcription was found.';

export function getTranscriptionLineTags(line: string) {
  const matchedLine = line.match(/\[(.*?)\] \((.*?)\): (.*)/);

  const name = matchedLine?.[1];
  const time = matchedLine?.[2];
  const text = matchedLine?.[3];

  return { name, time, text };
}
